import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Directive,
  ElementRef,
  Inject,
  Input,
  PLATFORM_ID,
} from '@angular/core';
import { SwiperContainer } from 'swiper/element';
import { SwiperOptions } from 'swiper/types';

@Directive({
  selector: '[appInitSwiper]',
})
export class SwiperDirective implements AfterViewInit {
  @Input() config?: SwiperOptions;

  constructor(
    private el: ElementRef<SwiperContainer>,
    @Inject(PLATFORM_ID) readonly platformId: Object
  ) {}

  ngAfterViewInit(): void {
    if (!this.config) {
      console.warn('SwiperDirective: No configuration provided.');
      return;
    }

    Object.assign(this.el.nativeElement, this.config);

    if (isPlatformBrowser(this.platformId)) {
      this.el.nativeElement.initialize();
      if (this.el.nativeElement.swiper) {
      }
    }
  }
}
